<div class="app-content">
  <ng-content></ng-content>
</div>
